import { FC } from "react";

import styles from "./AmenitySectionStyles.module.scss";
import { getIconName } from "../../RoomTypeSection/utils";
import LazyLoadOnScroll from "@Components/LazyLoadOnScroll";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";
import useWhitelabel from "hooks/useWhitelabel";

const Tag: FC<any> = ({
  value,
  icon,
  roomTypeSection = false,
  isDesktop = false,
  dataTestId = "",
  highlightText,

}) => {
  const rendericon = getIconName(
    icon,
    roomTypeSection ? "19px" : "24px",
    roomTypeSection ? "19px" : "24px",
  );
  const { t } = useTranslationHook();
  const { isWhitelabel } = useWhitelabel();
  const translateSQM = (stringName: string) => stringName?.replace(/\bsqm\s*$/i, t("sqm"));
  return (
      <div
      className={formatClassNames(
        isWhitelabel ? styles.WhitelabelTagContainer : styles.tagContainer,
        isDesktop ? styles.tagDesktop : "",
        roomTypeSection && styles.roomTypeSection,
      )}
    >
      <LazyLoadOnScroll
        customRootMargin="0px"
        fallback={
          <section
            style={{
              height: roomTypeSection ? "19px" : "24px",
              width: roomTypeSection ? "19px" : "24px",
            }}
          />
        }
      >
        {rendericon}
      </LazyLoadOnScroll>
      <div
        data-testid={dataTestId}
        title={value}
        className={roomTypeSection ? styles.tagTextSmall : styles.tagText}
      >
        {highlightText ? (
          <div dangerouslySetInnerHTML={{ __html: replaceAmberDomainInLinks(highlightText) }} />
        ) : (
          translateSQM(t(value))
        )}
      </div>    
    </div>
    
  );
};

export default wrapperHOC(Tag, {
  componentName: "Tag-AmenitySection-PropertyPage",
  showForChina: true,
});
